'use strict';

(function ($) {
    const self = Fotobook.draggable = {
        linesTimeout: null,
        dragLines: {
            vertical: ['left', 'right'],
            horizontal: ['top', 'bottom'],
        },
        hideGuideLines() {
            $('.guide-line').hide();
        },
        removeAlignLines($target) {
            $('.drag-align-lines', $target).remove();
        },
        rebuildAlignLines($target) {
            self.removeAlignLines($target);
            self.buildAlignLines($target);
        },
        buildLine(direction, position, classes) {
            return `<div data-direction="${direction}" data-position="${position}" class="drag-align-lines drag-${direction} ${position}-drag-line ${classes}" ></div>`;
        },
        buildCenterLines($target, linePosition = 'center') {
            const targetId = $target.attr('data-id') || 'box';
            const dragLines = [];
            if (linePosition === 'center') {
                Object.keys(self.dragLines).forEach((lineDirection) => {
                    const $dragLine = $(`>.drag-${lineDirection}.${linePosition}-drag-line`, $target);
                    if ($dragLine.length) {
                        return;
                    }
                    const classes = `drag-${targetId}`;
                    dragLines.push(self.buildLine(lineDirection, linePosition, classes));
                });
            } else {
                Object.keys(self.dragLines).forEach((lineDirection) => {
                    Object.keys(self.dragLines[lineDirection]).forEach((position) => {
                        linePosition = `${self.dragLines[lineDirection][position]}`;
                        const $dragLine = $(`>.drag-${lineDirection}.${linePosition}-drag-line.center-page`, $target);
                        if ($dragLine.length) {
                            return;
                        }
                        const classes = `center-page drag-${targetId}`;
                        dragLines.push(self.buildLine(lineDirection, linePosition, classes));
                    });
                });
            }
            $($target).append(dragLines.join(''));
        },
        buildCenterPageLines($target) {
            //build lines for snap by center container
            const $centerPageLines = $('.drag-align-lines.center-page');
            $.each($centerPageLines, (index, element) => {
                const $element = $(element);
                const linePosition = $element.attr('data-position');
                const lineDirection = $element.attr('data-direction');
                const $bookPage = $element.closest('.book-page');
                if (lineDirection === 'vertical') {
                    let left;
                    if (linePosition === 'left') {
                        left = $bookPage.width() / 2 - $target.width() / 2;
                    } else {
                        left = $bookPage.width() / 2 + $target.width() / 2;
                    }
                    //fix for cover pages
                    if ($element.parents('.pages-wrapper.cover .book-page.right').length) {
                        left += $element.parents('.book-page').width();
                    }
                    $element.css('left', left);
                } else {
                    let top;
                    if (linePosition === 'top') {
                        top = $bookPage.height() / 2 - $target.height() / 2;
                    } else {
                        top = $bookPage.height() / 2 + $target.height() / 2;
                    }
                    $element.css('top', top);
                }
            });
        },
        buildBorderLines($target) {
            const targetId = $target.attr('data-id') || 'box';
            const dragLines = [];
            Object.keys(self.dragLines).forEach((lineDirection) => {
                Object.keys(self.dragLines[lineDirection]).forEach((position) => {
                    const linePosition = self.dragLines[lineDirection][position];
                    const $dragLine = $(`>.drag-${lineDirection}.${linePosition}-drag-line`, $target);
                    if ($dragLine.length) {
                        return;
                    }
                    const classes = `drag-${targetId}`;
                    dragLines.push(self.buildLine(lineDirection, linePosition, classes));
                });
            });
            $($target).append(dragLines.join(''));
        },
        buildAlignLines($target) {
            // Append to $target element
            self.buildBorderLines($target);
            self.buildCenterLines($target);
        },
        snapped(event, ui) {
            const lineDirection = ui.snapElement.data('direction');
            const $line = $(`.guide-${lineDirection}`);
            if(ui.snapElement.hasClass('center-page')) {
                const verticalLine = $('.guide-vertical');
                const horizontalLine = $('.guide-horizontal');
                if(ui.isSnapCenter) {
                    verticalLine.css('left', ui.helper.offset().left - $(Fotobook.book.book).offset().left + ui.helper.width() / 2);
                    horizontalLine.css('top', ui.helper.offset().top - $(Fotobook.book.book).offset().top + ui.helper.height() / 2);
                }
                verticalLine.toggle(ui.isSnapCenter);
                horizontalLine.toggle(ui.isSnapCenter);
                return;
            }
            if (lineDirection === 'vertical') {
                $line.css('left', ui.snapElement.offset().left - $(Fotobook.book.book).offset().left);
            } else {
                $line.css('top', ui.snapElement.offset().top - $(Fotobook.book.book).offset().top);
            }
            if (self.linesTimeout) {
                clearTimeout(self.linesTimeout);
            }
            $line.toggle(ui.snappingKnown);
        },
        setDragLineSize(ui) {
            const $element = $(ui.helper);
            const position = $element.position();
            const $closestPage = $element.closest('.book-page');
            $element.find('.drag-horizontal').css({
                left: -position.left,
                width: $closestPage.width(),
            });
            $element.find('.drag-vertical').css({
                top: -position.top,
                height: $closestPage.height(),
            });
        },
    };

    $(document)
        .on('mouseover', '#book .page-container.top-level', function (event) {
            const $this = $(this);
            //отключение перетаскивания для фотонакладки
            if ($this.hasClass(Fotobook.CONT_SUBTYPE_FOTOWINDOW_CLASS)) {
                return;
            }
            const id = $this.attr('data-id');
            const draggable = $this.data('ui-draggable');
            const editMode = Fotobook.store.getters['OnlineEditor/editMode'].code;
            const options = {};
            const snapLines = `${Fotobook.book.book} .drag-align-lines:not(.drag-${id})`;
            Fotobook.draggable.buildCenterPageLines($this);
            const isInstantModeTextEnabled = Fotobook.config.data[Fotobook.Settings.SETTING_TEXT_IN_INSTANT_MODE_ENABLED];
            const isCaption = Number($this.attr('data-container-type')) === Fotobook.ContainerType.CAPTION;
            if (editMode === Fotobook.EditModeCode.INSTANT && (!isInstantModeTextEnabled || !isCaption)) {
                if (draggable) {
                    draggable.destroy();
                }
                return;
            }
            if (draggable) {
                return;
            }

            if ($this.hasClass('text-container')) {
                options.handle = '.drag-handle';
                if ($this.find('.drag-icon-handle').length === 0) {
                    $this.append($('<div class="drag-icon-handle drag-handle"></div>'));
                }
            }
            $this.draggable($.extend({
                cursor: 'move',
                cancel: '.locked',
                scroll: false,
                snap: snapLines,
                snapTolerance: 3,
                snapMode: 'outer',
                start(event, ui) {
                    const elements = $(Fotobook.book.book).find('.top-level.selected').not(ui.helper);
                    const dragData = [];
                    elements.each(function () {
                        const $this = $(this);
                        dragData.push({
                            element: $this,
                            left: parseFloat($this.css('left')),
                            top: parseFloat($this.css('top')),
                        });
                        Fotobook.book.backupInitialCoordinates($this, ['top', 'left']);
                    });
                    ui.helper.add(elements).closest('.cont-wrapper').addClass('dragging');
                    Fotobook.book.backupInitialCoordinates(ui.helper, ['top', 'left']);
                    ui.helper.data('fotobook-drag-data', dragData);
                    //отключение прилипания повернутых елементов
                    const isRotated = Number(ui.helper.css('--container-angle'));
                    let snap = isRotated ? false : snapLines;
                    ui.helper.draggable('option', 'snap', snap);

                    const $pagesWrapper = $(Fotobook.book.book + ' .pages-wrapper');
                    ui.helper.find('.drag-vertical').height($pagesWrapper.height()).css('top', 0);
                    ui.helper.find('.drag-horizontal').width($pagesWrapper.width()).css('left', 0);
                },
                drag(event, ui) {
                    self.setDragLineSize(ui);
                    const dragData = ui.helper.data('fotobook-drag-data');
                    const selection = Fotobook.book.getSelectionWidget();
                    const dx = ui.position.left - ui.originalPosition.left;
                    const dy = ui.position.top - ui.originalPosition.top;
                    ui.helper.trigger('update-container-toolbar');
                    for (let i = 0; i < dragData.length; i++) {
                        const e = dragData[i];
                        e.element.css({
                            left: `${e.left + dx}px`,
                            top: `${e.top + dy}px`,
                        });
                        dragData[i].element.trigger('update-container-toolbar');
                    }
                    if (selection) {
                        selection.updateToolbarPosition();
                    }
                    const $draggable = ui.helper.data('ui-draggable');
                    const snapElements = $draggable.snapElements.filter((element) => {
                        return element.snapping && $(element.item).hasClass('center-page');
                    }).map((element) => {
                        return element.item;
                    });
                    let isSnapCenter = true;
                    Object.keys(self.dragLines).forEach((lineDirection) => {
                        Object.keys(self.dragLines[lineDirection]).forEach((position) => {
                            const linePosition = self.dragLines[lineDirection][position];
                            if (!$(snapElements).hasClass(`${linePosition}-drag-line`)) {
                                isSnapCenter = false;
                            }
                        });
                    });
                    $.each($draggable.snapElements, (index, element) => {
                        const $item = $(element.item);
                        ui = $.extend({}, ui, {
                            isSnapCenter,
                            snapElement: $item,
                            snapping: element.snapping,
                        });
                        if (element.snapping && $item.data('direction')) {
                            if (!element.snappingKnown) {
                                element.snappingKnown = ui.snappingKnown = true;
                                self.snapped(event, ui);
                            }
                        } else if (element.snappingKnown && $item.data('direction')) {
                            element.snappingKnown = ui.snappingKnown = false;
                            self.snapped(event, ui);
                        }
                    });
                },
                stop(event, ui) {
                    const dragData = ui.helper.data('fotobook-drag-data');
                    let elements = ui.helper;

                    for (let i = 0; i < dragData.length; i++) {
                        elements = elements.add(dragData[i].element);
                    }
                    elements.closest('.cont-wrapper').removeClass('dragging');
                    if (!dragData.length) {
                        Fotobook.book.saveContainerPositionFotoOnBg(ui.helper, ['top', 'left']);
                    } else {
                        Fotobook.book.saveContainerPosition(elements, ['top', 'left']);
                    }
                    ui.helper.removeData('fotobook-drag-data');

                    // Костыль, так как данное событие stop срабатывает раньше, чем приходит клик в обработчик, открывающий панель редактирования
                    // из-за чего после перемещения контейнера срабатывало открытие редактора
                    $this.addClass('do-not-open-editor');
                    setTimeout(() => $this.removeClass('do-not-open-editor'), 0);
                    self.linesTimeout = setTimeout(self.hideGuideLines(), 100);
                },
            }, options));
        })
        .on(Fotobook.events.CHANGE_PAGE, () => {
            const pages = $('.book-page .overflow-limiter-container', Fotobook.book.book);
            //линии прилипания для границ страницы
            pages.each(function() {
                Fotobook.draggable.buildAlignLines($(this));
                Fotobook.draggable.buildCenterLines($(this), 'center-page');
            });
        })
        .on('resize', () => {
            setTimeout(() => {
                const $pagesWrapper = $(Fotobook.book.book + ' .book-page');
                $('.drag-vertical')
                    .height($pagesWrapper.height())
                    .css('top', 0);
                $('.drag-horizontal')
                    .width($pagesWrapper.width())
                    .css('left', 0);
            }, 10);
        });
})(jQuery);
